/*
 * @Author       : wenquan
 * @desc         : 组件描述
 * @Date         : 2022-01-17 10:12:30
 * @LastEditTime : 2024-07-18 14:43:11
 * @LastEditors  : shenqing
 * @FilePath     : \evalute-all\teaching_QualityService\src\api\api.js
 */
/*
 * @Author: wangyuanqin
 * @desc: 智慧就业-指导网
 * @Date: 2020-08-07 17:36:41
 * @LastEditTime: 2020-10-15 14:12:53
 * @LastEditors: wangyuanqin
 * @FilePath: \teaching_QualityService\src\api\api.js
 */
import Vue from "vue";
import { http, axios } from "./http.js";
import all from "./all.js";
// import qualityControl from "./qualityControl.js";
// import login from "./login.js";
// import center from "./center.js";
// import analyse from "./analyse.js";
// import control from "./control.js";
// import uses from "./uses.js";
/*eslint-disable */
export const api = {
  ...all,
};
Vue.prototype.$http = http;
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
// Vue.prototype.$url = config.url
Vue.prototype.$clientCategory = config.clientCategory;
Vue.prototype.$universityId = config.universityId;
Vue.prototype.$disapplyUniversityId = config.disapplyUniversityId;



// WEBPACK FOOTER //
// ./src/api/api.js